export const chains = {
  mainnet: 1,
  goerli: 5,
}
